import iconSearch from 'assets/image/icons/svg/search-icon-grey.svg'
import TextFieldCustom from 'components/atoms/TextFieldCustom'
import { campaignsActions, campaignsSelectors } from 'features/campaigns'
import { type PropsWithChildren, useState } from 'react'
import { useAppDispatch, useAppSelector, useUnMount } from 'shared/hooks'

export function Search({
	setPage
}: PropsWithChildren<{
	setPage(page: number): void
}>) {
	const keywords = useAppSelector(campaignsSelectors.search)
	const [search, setSearch] = useState(keywords)
	const dispatch = useAppDispatch()

	const onSearchEnter = () => {
		if (search !== keywords) {
			dispatch(campaignsActions.setSearch(search))
			setPage(0)
		}
	}

	useUnMount(() => {
		dispatch(campaignsActions.setSearch(search))
	})

	return (
		<div className='filter-search'>
			<TextFieldCustom
				endAdornment={
					<img
						alt='search'
						className='icon-search'
						onClick={onSearchEnter}
						src={iconSearch}
					/>
				}
				onBlur={onSearchEnter}
				onChange={e => setSearch(e.target.value)}
				onEnter={onSearchEnter}
				placeholder={'Search'}
				value={search}
			/>
		</div>
	)
}
